/** Sentinel testId used when no explicit test scope is provided. */
export const DEFAULT_TEST_ID = "__default__";
